export default "/images/img-3.jpg?282f0d0a9f400608e5fa603c6ea95adb";